import React, {Component} from 'react'
import PropTypes from 'prop-types'
import store from 'store'


export default class NRTAppContext extends Component {

    static TAG = `🔷 APP CONTEXT`
    static Provider = null
    static Consumer = null

    keysToPersist = null
    debug = false

    state = {}


    componentWillMount(){

        this.setState({ set: this.set})

        this.context = React.createContext({})

        NRTAppContext.Consumer = this.context.Consumer
        NRTAppContext.Provider = this.context.Provider

    }

    componentDidMount() {
        if (this.debug)
            this.logStateToConsole()

        this.debug = this.props.debug
        this.keysToPersist = this.props.keysToPersist

        this.setState({
            ...this.props.initialState,
            ...this.getPersistedState(),
        })


    }

    componentWillUnmount(){
        NRTAppContext.Consumer = null
        NRTAppContext.Provider = null
    }


    set = (changesObj, callback) => {
        this.setState(
            changesObj,
            () => {
                if (
                    Object.keys(changesObj)
                        .filter(key => this.keysToPersist.includes(key))
                        .length > 0
                ) {
                    this.persist()
                }

                if (this.debug)
                    this.logStateToConsole()

                if (callback)
                    callback()
            })
    }


    logStateToConsole() {
        console.info(NRTAppContext.TAG)
        console.info(this.state)
    }


    persist() {
        console.log(NRTAppContext.TAG + ' - persisting ')
        this.keysToPersist.forEach(key => store.set(key, this.state[key]))
    }


    getPersistedState() {
        const persistedState = {}
        this.keysToPersist.forEach(key => persistedState[key] = store.get(key) )

        return persistedState
    }


    render() {

        return (
            <NRTAppContext.Provider value={this.state}>
                {this.props.children}
            </NRTAppContext.Provider>
        )
    }
}


NRTAppContext.propTypes = {
    debug: PropTypes.bool,
    initialState: PropTypes.object.isRequired,
    keysToPersist: PropTypes.arrayOf(PropTypes.string).isRequired,
}

NRTAppContext.defaultProps = {
    debug: false,
}


export function withAppContext(Component) {

    return function WithAppContext(props) {

        return (
            <NRTAppContext.Consumer>
                {context => <Component {...props} context={context}/>}
            </NRTAppContext.Consumer>
        )
    }
}





// WEBPACK FOOTER //
// ./src/components/_common/AppContext/index.js